import { Link } from 'gatsby'
import { Picture } from 'src/components/ui/Image'

import type { BannerProductTabsBanner } from './types'

interface BannerCardProps {
  banner: BannerProductTabsBanner
  onSelect?: () => void
}

export function BannerCard({ banner, onSelect }: BannerCardProps) {
  const { backgroundImageDesktop, backgroundImageMobile, url } = banner

  const image = (
    <Picture
      className="block h-full w-full"
      sources={[
        {
          src: backgroundImageMobile ?? backgroundImageDesktop ?? '',
          width: 254,
          height: 254,
          media: '(max-width: 766px)',
        },
        {
          src: backgroundImageDesktop ?? backgroundImageMobile ?? '',
          width: 302,
          height: 302,
          media: '(min-width: 767px)',
        },
      ]}
      img={{
        src: backgroundImageDesktop ?? backgroundImageMobile ?? '',
        width: 302,
        height: 302,
        'data-id': backgroundImageDesktop ?? '',
        title: 'banner',
        alt: 'banner da vitrine',
        loading: 'lazy',
      }}
      shouldCompress={false}
    />
  )

  const className =
    'relative flex w-full min-w-[158px] sm:min-w-[254px] md:min-w-[302px] overflow-hidden'

  if (!url) {
    return <div className={className}>{image}</div>
  }

  return (
    <Link to={url} onClick={onSelect} className={className}>
      {image}
    </Link>
  )
}
